//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            opts: [
                {
                    text: '50㎡以下',
                    value: '0-50',
                    selected: false
                },
                {
                    text: '50-70㎡',
                    value: '50-70',
                    selected: false
                },
                {
                    text: '70-90㎡',
                    value: '70-90',
                    selected: false
                },
                {
                    text: '90-110㎡',
                    value: '90-110',
                    selected: false
                },
                {
                    text: '110-130㎡',
                    value: '110-130',
                    selected: false
                },
                {
                    text: '130-150㎡',
                    value: '130-150',
                    selected: false
                },
                {
                    text: '150㎡以上',
                    value: '150-999999999',
                    selected: false
                }
            ]
        }
    },
    onUnload () {
        this.reset()
    },
    methods: {
        onSelect (index) {
            const opt = this.opts[index]
            this.$set(this.opts, index, {
                ...opt,
                selected: !opt.selected
            })
        },
        reset () {
            this.opts.forEach((opt, i) => {
                opt.selected = false
            })
        },
        confirm () {
            const selected_items = this.opts.filter(({ selected, value }) => selected && value)
            this.$emit('change', selected_items.map(({ value }) => value).join(','), selected_items.map(({ text }) => text).join(','))
        }
    },
    props: {
        show: {
            type: Boolean
        }
    }
}
